import React from 'react'
import styled, { keyframes } from 'styled-components'
import { Loader2 } from 'lucide-react'
import Text from '../../../../../components/Text'
import TooltipWrapper from '../../../../../components/TooltipWrapper'

const PENDING_COLOR = '#8C96AD'

const INBOX_TAG_DOT_COLORS: Record<string, string> = {
    'Awaiting reply': '#5964FF',
    'To respond': '#03C9F7',
    Snoozed: '#D97706',
    'New connection': '#16D090',
    'New Connection': '#16D090',
    'Warm intro': '#FDBE00',
    SalesNav: '#4A9FE1',
    'Sales nav': '#4A9FE1',
    FYI: '#B8D7E3',
    Actioned: '#92D957',
    Marketing: '#FFC0CB',
}

interface IAiConversationTagProps {
    label?: string
    pending?: boolean
}

const AiConversationTag: React.FC<IAiConversationTagProps> = ({ label, pending }) => {
    if (pending) {
        return (
            <TooltipWrapper tooltipText="Tagging…" placement="top">
                <Chip>
                    <SpinWrap aria-hidden="true">
                        <Loader2 size={10} strokeWidth={1.5} />
                    </SpinWrap>
                    <Text $paragraph3 $bold $inheritColor $ellipsis="0">
                        Tagging…
                    </Text>
                </Chip>
            </TooltipWrapper>
        )
    }

    const displayLabel = label === 'SalesNav' ? 'Sales nav' : label
    const dotColor = label ? INBOX_TAG_DOT_COLORS[label] ?? INBOX_TAG_DOT_COLORS[displayLabel ?? ''] ?? PENDING_COLOR : PENDING_COLOR

    return (
        <TooltipWrapper tooltipText={displayLabel ?? ''} placement="top">
            <Chip>
                <Dot aria-hidden="true" $color={dotColor} />
                <Text $paragraph3 $bold $inheritColor $ellipsis="0">
                    {displayLabel}
                </Text>
            </Chip>
        </TooltipWrapper>
    )
}

const spin = keyframes`
    from { transform: rotate(0deg); }
    to   { transform: rotate(360deg); }
`

const Chip = styled.div`
    display: inline-flex;
    align-items: center;
    gap: 4px;
    max-width: 100%;
    min-width: 0;
    height: 20px;
    padding: 0 8px;
    border: 1px solid #dae0e8;
    border-radius: 12px;
    background-color: #fff;
    color: #41495e;
    box-sizing: border-box;

    span {
        min-width: 0;
        font-size: 12px;
        line-height: 20px;
        font-weight: 600;
    }
`

const Dot = styled.span<{ $color: string }>`
    width: 6px;
    height: 6px;
    flex: 0 0 6px;
    border-radius: 50%;
    background-color: ${({ $color }) => $color};
`

const SpinWrap = styled.span`
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    width: 8px;
    height: 8px;
    color: ${PENDING_COLOR};
    animation: ${spin} 1s linear infinite;
`

export default AiConversationTag
